export const THEME = "theme";
export const LIGHT = "LIGHT";
export const DARK = "DARK";
